import React, { useCallback } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

import { caseStatusOptions } from '../../constants/enums';

import './cases.scss';

const getClassName = (status) => {
  switch (status) {
    case caseStatusOptions.request:
      return 'calendar-view-event__request';
    case caseStatusOptions.booked:
      return 'calendar-view-event__booked';
    case caseStatusOptions.overdue:
      return 'calendar-view-event__overdue';
    case caseStatusOptions.completed:
      return 'calendar-view-event__completed';
    default:
      return '';
  }
};

const CasesCalendarView = (props) => {
  const {
    cases = [],
    onSelectCase,
    hospitals = [],
    surgeons = [],
    procedures = [],
    onDateChange,
  } = props;

  const getSurgeonName = useCallback(
    (surgeonId) => {
      const surgeon = surgeons.find((s) => s.id === surgeonId);
      return surgeon ? `${surgeon.title} ${surgeon.firstName} ${surgeon.lastName}` : '';
    },
    [surgeons]
  );

  const getHospitalName = useCallback(
    (hospitalId) => hospitals.find((h) => h.id === hospitalId)?.name || '',
    [hospitals]
  );

  const getProcedureName = useCallback(
    (procedureId) => procedures.find((p) => p.id === procedureId)?.name || '',
    [procedures]
  );

  const handleDatesSet = async (dateInfo) => {
    const { start, end } = dateInfo;
    await onDateChange(start, end);
  };

  return (
    <div style={{ width: '100%', marginTop: 16 }}>
      <FullCalendar
        plugins={[dayGridPlugin]}
        firstDay={1}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: '',
        }}
        initialView='dayGridMonth'
        events={cases?.map((item) => ({
          id: item.caseId,
          patientReference: item.patientReference,
          surgeonName: getSurgeonName(item.surgeon),
          hospitalName: getHospitalName(item.hospital),
          procedureName: getProcedureName(item.procedure),
          start: item.date,
          allDay: true,
          className: getClassName(item.status),
        }))}
        eventContent={renderEventContent}
        eventClick={(event) => onSelectCase(event?.event?.id)}
        datesSet={handleDatesSet}
      />
    </div>
  );
};

const renderEventContent = (event) => {
  const { patientReference, surgeonName, hospitalName, procedureName } = event.event.extendedProps;
  return (
    <div style={{ whiteSpace: 'pre-line' }}>
      <b>{surgeonName}</b>
      {patientReference && (
        <>
          <br />
          {patientReference}
        </>
      )}
      <br />
      {hospitalName}
      <br />
      {procedureName}
    </div>
  );
};

export default CasesCalendarView;
